export type TripPhase =
  | "pre_trip_early"   // > 30 Tage vor Start
  | "pre_trip_late"    // 7–30 Tage vor Start
  | "pre_trip_final"   // 1–7 Tage vor Start
  | "travel_day"       // Abreisetag
  | "in_progress"      // Unterwegs (nach Start, vor letztem Tag)
  | "last_day"         // Letzter Reisetag
  | "post_trip_fresh"  // 0–7 Tage nach Ende
  | "post_trip";       // > 7 Tage nach Ende

export function getTripPhase(startDate: string, endDate: string): TripPhase {
  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  const msPerDay = 1000 * 60 * 60 * 24;

  // Tages-Grenzen (Mitternacht)
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDayStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDayStart = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const endDayEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);

  const daysToStart = Math.ceil((startDayStart.getTime() - todayStart.getTime()) / msPerDay);
  const daysAfterEnd = Math.floor((todayStart.getTime() - endDayStart.getTime()) / msPerDay);

  // Nach der Reise
  if (now > endDayEnd) {
    return daysAfterEnd > 7 ? "post_trip" : "post_trip_fresh";
  }

  // Letzter Reisetag
  if (todayStart.getTime() === endDayStart.getTime()) {
    return "last_day";
  }

  // Unterwegs (zwischen Start und Ende, nicht letzter Tag)
  if (now >= start && now < endDayEnd) {
    return "in_progress";
  }

  // Abreisetag
  if (daysToStart === 0) {
    return "travel_day";
  }

  // Vor der Reise
  if (daysToStart <= 7) return "pre_trip_final";
  if (daysToStart <= 30) return "pre_trip_late";
  return "pre_trip_early";
}
